var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard7Clubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000061456787719770777720000011824749349084419970_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.6,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.7,294.4c0,18.1,5,36.1,6.7,41.8c0.3,0.9-0.4,1.8-1.4,1.8h-54.3c-1,0-1.7-0.9-1.4-1.8c1.7-5.7,6.7-24,6.7-41.8 c-7.2,5.2-15.5,7.9-24.7,7.9c-26.6,0-49.7-22.3-48-49.3c0.9-15.2,10.6-28.2,23.4-36.2c12.9-8.1,24.9-8.7,35.6-6.1 c-6.8-8.1-11-18.6-11-30c0-28.7,26-51.4,55.8-45.6c18.6,3.6,33.4,18.9,36.5,37.6c2.4,14.5-1.9,28-10.3,38 c10.8-2.6,22.8-1.9,35.8,6.3c12.8,8.1,22.4,21.1,23.3,36.2c1.6,26.9-21.6,49.1-48.2,49.1C190.4,302.3,181.8,299.5,174.7,294.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8,41.5c4,0,7.3-3.3,7.3-7.3s-3.3-7.3-7.3-7.3H29.1c-4,0-7.3,3.3-7.3,7.3s3.3,7.3,7.3,7.3H72.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4,34.2c0-4-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3v7.3c0,4,3.3,7.3,7.3,7.3s7.3-3.3,7.3-7.3V34.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,105.8c-0.7,4,2,7.7,6,8.4s7.7-2,8.4-6c5.1-30.1,10.8-44.2,28-70c2.2-3.3,1.3-7.9-2-10.1s-7.9-1.3-10.1,2 C48.5,57.7,42,73.6,36.5,105.8z"
  })), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.8,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S285.8,350.1,285.8,370.5z  M249,340c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S265.8,340,249,340z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.7,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C268,351.5,273.7,357.1,273.7,363.7z M268.6,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C265.1,371.2,268.6,367.9,268.6,363.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C254.9,380.4,258,383.2,258,386.7z  M253.8,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C252.6,389.3,253.8,388.2,253.8,386.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C244.1,361.1,242.7,359.9,241.1,359.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231.2,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S232.8,379.8,231.2,379.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M267,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C269.9,384.8,268.6,383.5,267,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 249,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063624937918360189690000018316823796053855384_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000063624937918360189690000018316823796053855384_)"
    },
    d: "M238.4,350.7 c-0.2,3.5-3.4,6.2-7.2,6c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C235.7,344.2,238.6,347.3,238.4,350.7z M234.1,350.5 c0.1-1.4-1-2.6-2.5-2.7c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C232.8,353,234.1,351.9,234.1,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7Clubs);
export default __webpack_public_path__ + "static/media/card_7-clubs.7d93f426b83f4c0ce93fa4b9e472c1b8.svg";
export { ForwardRef as ReactComponent };